import { Route } from 'react-router';
import NavLayout from '../contexts/shared/components/layouts/NavLayout'
import Login from '../contexts/frontoffice/auth/ui/pages/Login'
import Clear from '../contexts/shared/pages/Clear'
import Register from '../contexts/frontoffice/auth/ui/pages/Register'
import RememberPassword from '../contexts/backoffice/auth/ui/RememberPassword'
import AssignPassword from '../contexts/frontoffice/auth/ui/pages/AssignPassword'
import NotFound from '../contexts/shared/pages/NotFound'

export const NavRoutes = (
  <Route path="/" element={<NavLayout />}>
    <Route index element={<Login />} />
    <Route path="limpiar" element={<Clear />} />
    <Route path="iniciar-sesion" element={<Login />} />
    <Route path="registro" element={<Register />} />
    <Route path="recordar-contrasena" element={<RememberPassword />} />
    <Route path="recordar-contrasena/:token" element={<RememberPassword />} />
    <Route path="asignar-contrasena/:token" element={<AssignPassword />} />
    <Route path="*" element={<NotFound />} />
  </Route>
);
